"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var convert_1 = __importDefault(require("./util/convert"));
var ed25519_1 = __importDefault(require("./ed25519"));
//@ts-ignore
var blakejs_1 = require("blakejs");
var Signer = /** @class */ (function () {
    function Signer() {
        this.ed25519 = new ed25519_1.default();
    }
    /**
     * Signs any data using the ed25519 signature system
     *
     * @param privateKey Private key to sign the data with
     * @param data Data to sign
     */
    Signer.prototype.sign = function (privateKey) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var signature = this.ed25519.sign(this.generateHash(data), convert_1.default.hex2ab(privateKey));
        return convert_1.default.ab2hex(signature);
    };
    /**
     * Creates a blake2b hash of the input data
     *
     * @param data Data to hash
     */
    Signer.prototype.generateHash = function (data) {
        var ctx = blakejs_1.blake2bInit(32, undefined);
        data.forEach(function (str) { return blakejs_1.blake2bUpdate(ctx, convert_1.default.hex2ab(str)); });
        return blakejs_1.blake2bFinal(ctx);
    };
    return Signer;
}());
exports.default = Signer;
